module.exports = __webpack_public_path__ + "static/react-chrome-stats-11672526a8d6873b047a914bde0614c8.png";